<template>
  <div class="navbar_wrap hidden-xs-only" >
    <div class="navbar_container">
      <div class="navbar_left">
        <img src="@/assets/img/home/logoNew1.png"  @click="goHome" alt="" style="width: 100%;"  />
        <!-- <h2>
          <a href="/home" style="color: #000000;">
            河南中豫国际港务集团有限公司 
           
          </a>
          <a style="font-size:8px !important;color: #000000;display: inline-block;"> 
              HENAN ZHONGYU INTERNATIONAL PORT GROUP CO., LTD
            </a>
            
        
        </h2> -->
      </div>
      <div class="navbar_right">
        <el-menu
          :default-active="activeIndex"
          class="el_menu_demo"
          mode="horizontal"
          
          @select="changeCurrentPage"
        >
          <el-menu-item index="1" class="menu_item">首页</el-menu-item> 
          <el-menu-item index="gw2" class="menu_item">集团简介</el-menu-item>
          <el-menu-item index="gw3" class="menu_item">新闻动态</el-menu-item>
          <el-menu-item index="4" class="menu_item">业务板块</el-menu-item>
          <!-- <el-menu-item index="6" class="menu_item">党建园地</el-menu-item> -->
          <el-menu-item index="nsc" class="menu_item">党建纪检</el-menu-item>
          <el-menu-item index="5" class="menu_item">信息公开</el-menu-item>
          <!-- <el-menu-item index="CgList" class="menu_item">采购信息</el-menu-item> -->
          <!-- <el-menu-item index="contact" class="menu_item">交流中心</el-menu-item> -->
          <el-menu-item index="tolent" class="menu_item">人才中心</el-menu-item>
          <el-menu-item index="telMsg" class="menu_item">联系我们</el-menu-item>
          <el-menu-item index="searchMsg" class="menu_item"><i class="el-icon-search"></i></el-menu-item>
          
        </el-menu>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: '1',
      navBackground:'#fff'
    }
  },
  props: {
    selectIndex: {
      type: String,
      default: '0',
    },
  },
  mounted() {
    this.activeIndex = this.selectIndex
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 390){
        this.navBackground = '#000'
      }else{
        this.navBackground = '#fff'
      }
    }
  },
  methods: {
     goHome(){
      this.$router.push('/home')
    },
    changeCurrentPage(index) {
      this.activeIndex = index
      switch (this.activeIndex) {
        case '1':
          this.$router.push('/home').catch((v) => {})
          break
        case 'gw2':
          this.$router.push('/gk').catch((v) => {})
          break
        case 'gw3':
          this.$router.push('/news').catch((v) => {})
          break
        case 'nsc':
        this.$router.push('/nsc').catch((v) => {})
        break
        case 'CgList':
        this.$router.push('/CgList').catch((v) => {})
        break
        case 'contact':
        this.$router.push('/contact').catch((v) => {})
        break
        case 'tolent':
        this.$router.push('/tolent').catch((v) => {})
        break
        case 'telMsg':
        this.$router.push('/telMsg').catch((v) => {})
        break
        case 'searchMsg':
        this.$router.push('/searchMsg').catch((v) => {})
        break
        case '2-1':
          this.$router.push('/production/1').catch((v) => {})
          break
        case '2-2':
          this.$router.push('/production/2').catch((v) => {})
          break
        case '2-3':
          this.$router.push('/production/3').catch((v) => {})
          break
        case '2-4':
          this.$router.push('/production/4').catch((v) => {})
          break
        case '3':
          this.$router.push('/threenav').catch((v) => {})
          break
          case '4':
          this.$router.push('/business').catch((v) => {})
          break
          case '5':
          this.$router.push('/infoopen').catch((v) => {})
          break
          case '6':
          this.$router.push('/dangBuilding').catch((v) => {})
          break
          
        default:
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-menu--horizontal>.el-menu-item{
  font-size: 1.1rem;
  color: #000000;
  border-bottom: none;
  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }

         

        /* 台式机 (可能更大或比例不同) */
        @media screen and (min-width: 1920px),
              screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
                font-size: 1.1rem;
        }
}
.el-menu--horizontal>.el-menu-item.is-active{
  // color: #0038a4;
  color: #000000;
  font-weight: 600;
  border-bottom: none;

}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
  // color: #0038a4;
    color: #000000;

}
.navbar_wrap {
  width: 100%;
  height: 80PX;
  background:#ffffff;
  // backdrop-filter: saturate(180%) blur(0.5rem);
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  .navbar_container {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        width: 460px;
        cursor: pointer;
      }
      h2{
        width: 25rem !important;
        // background: red;
        color: #0038a4;
        
      }
    }
    .navbar_right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 20px;
      a {
        text-decoration: none;
        color: #0038a4;
        display: inline-block;
        width: 100px;
        background: #ffa400;
        line-height: 27px;
        text-align: center;
        border-radius: 20px;
        padding: 5px;
      }
      .el_menu_demo {
        border: none;
      }
      .menu_item {
        &:hover {
          // color: #0038a4;
          color: #000000;
          font-weight: 600;
          background: transparent !important;
        }
        // padding-left: 0.85rem;
        // padding-right: 0.85rem;

                  /* 笔记本电脑 (通常16:9比例) */
        @media screen and (min-width: 1366px) and 
              (max-width: 1919px) and 
              (min-aspect-ratio: 16/9) {
                padding-left: 0.85rem;
                padding-right: 0.85rem;
        }

        /* 台式机 (可能更大或比例不同) */
        @media screen and (min-width: 1920px),
              screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
                padding-left: 1.25rem;
                padding-right: 1.25rem;
        }

      }

    

      .right_phone {
        &:hover {
          color: #2338d8;
        }
        transition: all 0.5s;
        display: flex;
        align-items: center;
        i {
          font-size: 20px;
        }
        span {
          margin-left: 0.5rem;
        }
        margin-left: 2.5rem;
        color: #121010;
      }
    }
  }
}
</style>